/* eslint-disable @typescript-eslint/no-unused-vars */
import { IPresentationModel } from '@src/slide/domain/ui-model/element-modeles/Interface/presentation-model.interface';
import {
    IElementNode,
    ISlideNode,
    ITextElementBoxNode,
    ITextParagraphBoxNode,
} from '../../slide-content-enumerator/enumerator-types.interface';

/**
 * 模版检查解析器
 * 模版检查器使用一个或多个解析器解析文档，每个解析器都会输出自己的解析结果
 */
export interface IBaseAnalyzer<IResult> {
    /**
     * 解析器的解析结果
     */
    result: Promise<IResult>;
    /**
     * 开始遍历的回调
     */
    onPresentationStart(): void;
    /**
     * 开始遍历 slide 的回调
     */
    onSlideStart(slide: ISlideNode): void;
    /**
     * 结束遍历 slide 的回调（slide 里的元素全部遍历完毕）
     */
    onSlideEnd(slide: ISlideNode): void;
    /**
     * 遍历到 element 的回调
     */
    onElement(element: IElementNode): void;
    /**
     * 遍历到段落的回调
     */
    onParagraphParentBox(textParagraphBoxNode: ITextParagraphBoxNode): void;
    /**
     * 遍历到最小文本块的回调
     * 此文本块有相同的字体、文字大小、颜色等
     */
    onTextElementBox(textElementBoxNode: ITextElementBoxNode): void;
    /**
     * 文档遍历完毕的回调，在遍历完毕时计算解析结果
     */
    calculateResult(presentation: IPresentationModel): Promise<IResult>;
}

/**
 * 解析器基类
 */
export abstract class BaseAnalyzer<IResult> implements IBaseAnalyzer<IResult> {
    public result: Promise<IResult>; // 解析结果，用于临时存储结果，不重写
    public onPresentationStart(): void {}
    public onSlideStart(slide: ISlideNode): void {}
    public onSlideEnd(slide: ISlideNode): void {}
    public onElement(element: IElementNode): void {}
    public onParagraphParentBox(textParagraphBoxNode: ITextParagraphBoxNode): void {}
    public onTextElementBox(textElementBoxNode: ITextElementBoxNode): void {}
    public abstract calculateResult(presentation: IPresentationModel): Promise<IResult>;
}
